<app-companies-nav [activeMenuItem]="'products'"></app-companies-nav>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<mat-autocomplete #autoLimitGroups="matAutocomplete">
  <mat-option *ngFor="let limitGroup of limitGroups" [value]="limitGroup.code">
    {{ limitGroup.code }} <small style="color: dimgrey">{{ limitGroup.description}}</small>
  </mat-option>
</mat-autocomplete>

<mat-autocomplete #autoPermsGroups="matAutocomplete">
  <mat-option *ngFor="let permsGroup of permsGroups" [value]="permsGroup.code">
    {{ permsGroup.code }} <small style="color: dimgrey">{{ permsGroup.description}}</small>
  </mat-option>
</mat-autocomplete>

<mat-autocomplete #autoFeeGroups="matAutocomplete">
  <mat-option *ngFor="let feeGroup of feeGroups" [value]="feeGroup.code">
    {{ feeGroup.code }} <small style="color: dimgrey">{{ feeGroup.description}}</small>
  </mat-option>
</mat-autocomplete>

<mat-autocomplete #autoWhiteLists="matAutocomplete">
  <mat-option *ngFor="let whiteList of whiteLists" [value]="whiteList.listCode">
    {{ whiteList.listCode }}
  </mat-option>
</mat-autocomplete>

<mat-autocomplete #autoBlackLists="matAutocomplete">
  <mat-option *ngFor="let blackList of blackLists" [value]="blackList.listCode">
    {{ blackList.listCode }}
  </mat-option>
</mat-autocomplete>

<form *ngIf="productForm" [formGroup]="productForm" (ngSubmit)="onSubmit(productForm)">


  <div fxLayout="row" fxLayoutGap="10px">

    <div fxFlex="50" fxFlex.md="50" fxFlex.sm="100" fxLayoutGap="10px">

      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h5>Product</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div>
            <input #fileInput type="file" [style.display]="'none'" (change)="uploadImage($event)">
            <mat-icon *ngIf="!productForm.value.logoUrl" class="logo-clear" (click)="fileInput.click()">add_a_photo</mat-icon>

            <img *ngIf="productForm.value.logoUrl" class="logo-large" [src]="productForm.value.logoUrl" (click)="fileInput.click()">
            <mat-icon class="button-icon" *ngIf="productForm.value.logoUrl" (click)="fileInput.click()" aria-label="Edit"  >edit  </mat-icon>
            <mat-icon class="button-icon" *ngIf="productForm.value.logoUrl" (click)="resetLogoInput() " aria-label="Delete">delete</mat-icon>

          </div>

          <div style="margin-top: 15px; margin-bottom: 10px;">
            <mat-slide-toggle formControlName="active">Active</mat-slide-toggle>
          </div>

          <mat-form-field>
            <input matInput placeholder="Product Key" formControlName="productKey" maxlength="50">
          </mat-form-field>
          <small style="background-color: yellow; padding: 2px; border-radius: 3px;">Consult with IT if unsure</small>
          <br />
          <br />
          <mat-form-field>
            <input matInput placeholder="Name" formControlName="name" maxlength="50" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Internal Name" formControlName="internalName" maxlength="20">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Short Name" formControlName="shortName" maxlength="20">
          </mat-form-field>
          <mat-form-field>
            <mat-select placeholder="Company" formControlName="companyId" required>
              <mat-option *ngFor="let company of companies" [value]="company.id">{{company.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="Partner Price" formControlName="partnerPrice" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Cancellation period (days)" formControlName="cancellationPeriodDays" type="number">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Minimal contract period months" formControlName="minimalContractPeriodMonths" type="number">
          </mat-form-field>


          <h5>Primary Product</h5>
          <div>Choose if this product can be ordered as a primary card during onboarding</div>
          <div style="margin-top: 15px; margin-bottom: 10px;">
            <mat-slide-toggle formControlName="canOrderAsPrimary">Can be ordered as a primary</mat-slide-toggle>
          </div>

          <div>Use this to define this product as a secondary product for linked cards</div>
          <mat-form-field>
            <mat-select placeholder="Primary Product" formControlName="primaryProductId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option [disabled]="product.id == productId" *ngFor="let product of products" [value]="product.id">{{product.id}} - {{product.internalName}}</mat-option>
            </mat-select>
          </mat-form-field>

          <h5>Replacement</h5>
          <div>Use this to define a replacement product for this product for e.g. Re-Orders</div>
          <mat-form-field>
            <mat-select placeholder="Replacement Product" formControlName="replacementProductId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option [disabled]="product.id == productId" *ngFor="let product of products" [value]="product.id">{{product.id}} - {{product.name}}</mat-option>
            </mat-select>
          </mat-form-field>


          <h5>Images</h5>
          <div>Use this to set images for this product</div>

          <b>Logo</b>

          <mat-form-field>
            <mat-select placeholder="Logo" formControlName="logoId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <b>Img</b>

          <mat-form-field>
            <mat-select placeholder="Logo" formControlName="imgId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <b>Legacy Apps until 1.0.11</b>
          <mat-form-field>
            <mat-select placeholder="Clean Card Image" formControlName="cleanCardImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <b>Product Image</b><br />
          <b>Background Image</b>

          <mat-form-field>
            <mat-select placeholder="Background Image" formControlName="backgroundImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <b>Overlays</b>

          <mat-form-field>
            <mat-select placeholder="Overlay 1" formControlName="overlay1ImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Overlay 2" formControlName="overlay2ImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Overlay 3" formControlName="overlay3ImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Overlay 4" formControlName="overlay4ImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <b>Virtual Only - Image</b><br />
          <b>Background Image</b>

          <mat-form-field>
            <mat-select placeholder="Logo" formControlName="virtualOnlyBackgroundImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <b>Overlays</b>

          <mat-form-field>
            <mat-select placeholder="Overlay 1" formControlName="virtualOnlyOverlay1ImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Overlay 2" formControlName="virtualOnlyOverlay2ImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Overlay 3" formControlName="virtualOnlyOverlay3ImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field>
            <mat-select placeholder="Overlay 4" formControlName="virtualOnlyOverlay4ImageId">
              <mat-option [value]="null"><i>--- none ---</i></mat-option>
              <mat-option *ngFor="let upload of productUploads" [value]="upload.id">
                <div style="display: inline-block; width: 50px; height: 30px; text-align: center">
                  <img src="{{environment.apiUrl + upload.fileName}}" style="height: 30px; max-width: 50px" [alt]="'upload-' + upload.id" />
                </div>
                {{upload.id}} - {{upload.originalFileName}}
              </mat-option>
            </mat-select>
          </mat-form-field>


          <br /><br />
          <b>Appearance</b>
          <div style="margin-top: 15px; margin-bottom: 10px;">
            <mat-slide-toggle formControlName="textDark">Dark text</mat-slide-toggle><br />
            <small>Set this to on if cards of this product should display their text in dark color</small>
          </div>


        </mat-card-content>
      </mat-card>



      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h5>Card creation</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <mat-form-field>
            <input matInput placeholder="Card design" formControlName="cardDesign" required>
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="Card design" formControlName="cardDesignVirtual">
          </mat-form-field>
          <small>
            Fill if virtual product has different card design than physical. If left blank, "Card design" is used.<br />
            Will be overriden by SDD Card design if applicable.

          </small>
          <br />

          <mat-form-field>
            <mat-select placeholder="Create type" formControlName="createType" required>
              <mat-option [value]="1">1 = Virtual</mat-option>
              <mat-option [value]="2">2 = Physical</mat-option>
              <mat-option [value]="4">4 = MVC</mat-option>
              <mat-option [value]="900">900 = Pseudo-Card</mat-option>
            </mat-select>

          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="FDD Limit group" required formControlName="limitsGroup" [matAutocomplete]="autoLimitGroups">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="FDD Perms group" formControlName="permsGroup" required [matAutocomplete]="autoPermsGroups">
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="EDD Limit group" formControlName="eddLimitGroup" [matAutocomplete]="autoLimitGroups">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="EDD Perms group" formControlName="eddPermsGroup" [matAutocomplete]="autoPermsGroups">
          </mat-form-field>

          <div>
            <div style="margin-top: 15px; margin-bottom: 10px;">
              <mat-slide-toggle formControlName="isNoIdentCreationActive">SDD - Creation active</mat-slide-toggle>
            </div>
          </div>

          <!-- no ident -->
          <mat-form-field>
            <input matInput placeholder="SDD Card design" formControlName="cardDesignNoIdent">
          </mat-form-field>
          <mat-form-field>
            <mat-select placeholder="SDD Create type" formControlName="createTypeNoIdent">
              <mat-option [value]="1">1 = Virtual</mat-option>
              <mat-option [value]="900">900 = Pseudo-Card</mat-option>
            </mat-select>

          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="SDD Limit group" formControlName="limitsGroupNoIdent" [matAutocomplete]="autoLimitGroups">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="SDD Perms group" formControlName="permsGroupNoIdent" [matAutocomplete]="autoPermsGroups">
          </mat-form-field>

          <div>
            <div style="margin-top: 15px; margin-bottom: 10px;">
              <mat-slide-toggle formControlName="convertToPhysicalAfterIdent">Convert to physical on Ident</mat-slide-toggle>
            </div>
          </div>

          <br /><br />

          <mat-form-field>
            <input matInput placeholder="Product ref" formControlName="productRef" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Curr code" formControlName="currCode" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Lang" formControlName="lang" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Load value" formControlName="loadValue" type="number">
          </mat-form-field>


          <mat-checkbox formControlName="createConvertToPhysical">Instant convert to physical</mat-checkbox>

          <mat-form-field>
            <input matInput placeholder="Image id" formControlName="imageId" type="number">
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="Fee group" formControlName="feeGroup" [matAutocomplete]="autoFeeGroups">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Carrier type" formControlName="carrierType" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Sms required" formControlName="smsRequired" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Mail or sms" formControlName="mailOrSms" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Action" formControlName="action" type="number">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Delv Method" formControlName="delvMethod" type="number" required>
          </mat-form-field>


          <mat-form-field>
            <input matInput placeholder="GPS product ID" formControlName="productId" type="number">
          </mat-form-field>


          <mat-form-field>
            <input matInput placeholder="Card Acceptor Allow List (Whitelist)" formControlName="whiteListCode" [matAutocomplete]="autoWhiteLists">
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="Card Acceptor Deny List (Blacklist)" formControlName="blackListCode" [matAutocomplete]="autoBlackLists">
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="Display Design" formControlName="displayDesign">
          </mat-form-field>

          <div style="margin-top: 15px; margin-bottom: 10px;">
            <mat-slide-toggle formControlName="virtualOnly">Only virtual cards</mat-slide-toggle><br />
            <small>Set this to on if cards of this product should never be converted to physical</small>
          </div>


        </mat-card-content>
      </mat-card>


      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h5>Cashback</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>



          <mat-slide-toggle formControlName="cashbackActive">Cashback active</mat-slide-toggle>
          <br />
          <mat-form-field>
            <input matInput placeholder="Factor" formControlName="cashbackFactor" type="number" required>
          </mat-form-field>
          <small>e.g. 0.01 = 1%, 0.005 = 0.5%</small>
          <br />
          <mat-form-field>
            <input matInput placeholder="Max. per Month" formControlName="cashbackMaxPerMonth" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Max. per Transaction" formControlName="cashbackMaxPerTransaction" type="number" required>
          </mat-form-field>

        </mat-card-content>
      </mat-card>

    </div>
    <div fxFlex="50" fxFlex.md="50" fxFlex.sm="100" fxLayoutGap="10px">

      <mat-card>
        <mat-card-content>
          <div class="text-right">
            <button mat-raised-button color="accent" type="button" (click)="returnBack()">Cancel</button>
            <button mat-raised-button color="primary" type="submit" [disabled]="!productForm.valid">Save</button>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h5>Loads</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <h5>Instant Loading</h5>
          <div style="margin-top: 15px; margin-bottom: 10px;">
            <mat-slide-toggle formControlName="isInstantLoadEnabled">Instant Loads enabled</mat-slide-toggle><br />
            <small>Enables the creation of Instant Loads via Bank Transfer or Partner Wallet for this producs</small>
          </div>

        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h5>Fees</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>

          <div style="margin-top: 20px; margin-bottom: 5px;">
            <b>Running and Issuing fees</b>
          </div>

          <mat-form-field>
            <input matInput placeholder="Annual Fee" formControlName="annualFee" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Annual Fee from 2nd year" formControlName="annualFeeFromSecondYear" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Issuing Fee" formControlName="issuingFee" type="number" required>
          </mat-form-field>


          <mat-form-field>
            <input matInput placeholder="First months free" formControlName="firstMonthsFree" type="number" required>
          </mat-form-field>
          <div>
            <small>The first annual fee will be delayed for this number of months. Subsequent annual fees will then be due 12 months after the first annual fee</small>
          </div>


          <div style="margin-top: 20px; margin-bottom: 5px;">
            <b>Under 26</b>
          </div>


          <div style="margin-top: 15px; margin-bottom: 10px;">
            <mat-slide-toggle formControlName="under26PromotionActive">Under 26 - promotion active</mat-slide-toggle><br />
            <small>Enables the automatic setting of a different annual fee for persons under 26 years of age </small>
          </div>
          <mat-form-field>
            <input matInput placeholder="Annual Fee Under 26" formControlName="annualFeeUnder26" type="number">
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Annual Fee from 2nd year Under 26" formControlName="annualFeeFromSecondYearUnder26" type="number">
          </mat-form-field>

          <div style="margin-top: 20px; margin-bottom: 5px;">
            <b>Loads via SEPA Bank Transfer</b>
          </div>


          <mat-form-field>
            <input matInput placeholder="SEPA Load Fee - Percent" formControlName="loadFeePercent" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="SEPA Load Fee - Fixed" formControlName="loadFeeFixed" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="SEPA Load Fee - Minimum" formControlName="loadFeeMinimum" type="number" required>
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="SEPA Load Fee - Maximum" formControlName="loadFeeMaximum" type="number">
          </mat-form-field>

          <div style="margin-top: 20px; margin-bottom: 5px;">
            <b>Loads from Partner Wallet</b>
          </div>
          <mat-form-field>
            <input matInput placeholder="Wallet Load Fee - Percent" formControlName="walletLoadFeePercent" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Wallet Load Fee - Fixed" formControlName="walletLoadFeeFixed" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="Wallet Load Fee - Minimum" formControlName="walletLoadFeeMinimum" type="number" required>
          </mat-form-field>

          <mat-form-field>
            <input matInput placeholder="Wallet Load Fee - Maximum" formControlName="walletLoadFeeMaximum" type="number">
          </mat-form-field>


          <div style="margin-top: 20px; margin-bottom: 5px;">
            <b>Card To Card Sender Fees</b>
          </div>


          <mat-form-field>
            <input matInput placeholder="C2C Send Fee - Percent" formControlName="cardToCardFeePercent" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="C2C Send Fee - Fixed" formControlName="cardToCardFeeFixed" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="C2C Send Fee - Minimum" formControlName="cardToCardFeeMinimum" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="C2C Send Fee - Maximum" formControlName="cardToCardFeeMaximum" type="number">
          </mat-form-field>


          <div style="margin-top: 20px; margin-bottom: 5px;">
            <b>Card To Card Receiver Fees</b>
          </div>


          <mat-form-field>
            <input matInput placeholder="C2C Receive Fee - Percent" formControlName="cardToCardReceiveFeePercent" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="C2C Receive Fee - Fixed" formControlName="cardToCardReceiveFeeFixed" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="C2C Receive Fee - Minimum" formControlName="cardToCardReceiveFeeMinimum" type="number" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="C2C Receive Fee - Maximum" formControlName="cardToCardReceiveFeeMaximum" type="number">
          </mat-form-field>


          <div style="margin-top: 20px; margin-bottom: 5px;">
            <b>Card virtual-to-physical conversion fee</b>
          </div>


          <mat-form-field>
            <input matInput placeholder="Card conversion fee" formControlName="cardConversionFee" type="number" required>
          </mat-form-field>

          <h5>Collection</h5>

          <div style="margin-top: 15px; margin-bottom: 10px;">
            <mat-slide-toggle formControlName="isDebtCollectionEnabled">Debt collection enabled</mat-slide-toggle><br />
            <small>Enables the transfer of unpaid invoices for this product to collection agencies</small>
          </div>

          <h5>Annual Fee Deduction and Invoicing</h5>

          <div style="margin-top: 15px; margin-bottom: 10px;">
            <mat-slide-toggle formControlName="skipAnnualFeeDeduction">Skip annual fee deduction</mat-slide-toggle><br />
            <small>Skips automatic deduction of annual fee from card when there is enough balance</small>
          </div>

          <div style="margin-top: 15px; margin-bottom: 10px;">
            <mat-slide-toggle formControlName="skipAnnualFeeInvoiceGeneration">Skip annual fee invoice generation</mat-slide-toggle><br />
            <small>Skips automatic creation of annual fee invoices (when amount could not be deducted or deduction is skipped)</small>
          </div>
        </mat-card-content>
      </mat-card>


      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h5>Product Limits</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>



          <h5>SDD</h5>
          <mat-form-field>
            <input matInput placeholder="SDD Daily Load Limit" formControlName="sddDailyLoadLimit" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="SDD Monthly Load Limit" formControlName="sddMonthlyLoadLimit" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="SDD Yearly Load Limit" formControlName="sddYearlyLoadLimit" required>
          </mat-form-field>
          <br />
          <mat-form-field>
            <input matInput placeholder="SDD Daily Load Frequency" formControlName="sddDailyLoadFrequency" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="SDD Monthly Load Frequency" formControlName="sddMonthlyLoadFrequency" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="SDD Yearly Load Frequency" formControlName="sddYearlyLoadFrequency" required>
          </mat-form-field>
          <br />
          <mat-form-field>
            <input matInput placeholder="SDD Max Balance" formControlName="sddMaxBalance" required>
          </mat-form-field>

          <h5>FDD</h5>
          <mat-form-field>
            <input matInput placeholder="FDD Daily Load Limit" formControlName="fddDailyLoadLimit" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="FDD Monthly Load Limit" formControlName="fddMonthlyLoadLimit" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="FDD Yearly Load Limit" formControlName="fddYearlyLoadLimit" required>
          </mat-form-field>
          <br />
          <mat-form-field>
            <input matInput placeholder="FDD Daily Load Frequency" formControlName="fddDailyLoadFrequency" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="FDD Monthly Load Frequency" formControlName="fddMonthlyLoadFrequency" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="FDD Yearly Load Frequency" formControlName="fddYearlyLoadFrequency" required>
          </mat-form-field>
          <br />
          <mat-form-field>
            <input matInput placeholder="FDD Max Balance" formControlName="fddMaxBalance" required>
          </mat-form-field>

          <h5>EDD</h5>
          <mat-form-field>
            <input matInput placeholder="EDD Daily Load Limit" formControlName="eddDailyLoadLimit" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="EDD Monthly Load Limit" formControlName="eddMonthlyLoadLimit" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="EDD Yearly Load Limit" formControlName="eddYearlyLoadLimit" required>
          </mat-form-field>
          <br />
          <mat-form-field>
            <input matInput placeholder="EDD Daily Load Frequency" formControlName="eddDailyLoadFrequency" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="EDD Monthly Load Frequency" formControlName="eddMonthlyLoadFrequency" required>
          </mat-form-field>
          <mat-form-field>
            <input matInput placeholder="EDD Yearly Load Frequency" formControlName="eddYearlyLoadFrequency" required>
          </mat-form-field>
          <br />
          <mat-form-field>
            <input matInput placeholder="EDD Max Balance" formControlName="eddMaxBalance" required>
          </mat-form-field>

        </mat-card-content>
      </mat-card>

    </div>

  </div>

  <div fxLayout="row" fxLayoutGap="10px">

    <div fxFlex="50" fxFlex.md="50" fxFlex.sm="100" fxLayoutGap="10px">

      <mat-card>
        <mat-card-header>
          <mat-card-title>
            <h5>App Settings</h5>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>




          <mat-slide-toggle formControlName="showPlayStoreIcon">Show Google Play Store Link</mat-slide-toggle>
          <br />
          <mat-form-field>
            <input matInput placeholder="https://..." formControlName="playStoreLink" type="text">
          </mat-form-field>
          <small>include https://</small>
          <br />
          <mat-slide-toggle formControlName="showAppStoreIcon">Show Apple App Store Link</mat-slide-toggle>
          <br />
          <mat-form-field>
            <input matInput placeholder="https://..." formControlName="appStoreLink" type="text">
          </mat-form-field>
          <small>include https://</small>

          <br /><br />
          <mat-form-field>
            <input matInput placeholder="brand1,brand2" formControlName="appsList" maxlength="50">
          </mat-form-field>
          <small>Comma-separated list of app brand codes that can order this product</small>



        </mat-card-content>
        <mat-card-actions align="end">
          <button mat-raised-button color="accent" type="button" (click)="returnBack()">Cancel</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="!productForm.valid">Save</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</form>



